<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15zjZ2o/tc-custom/9781788852319.jpg?1716663321622" alt="This image is the cover for the book Insurrection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Insurrection
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>On the Other Side of Sorrow</i> gives a detailed account of the causes and effects of the Scottish potato famine that began in 1846.</b><br/><br/> When Scotland’s 1846 potato crop was wiped out by blight, the country was plunged into crisis. In the Hebrides and the West Highlands, a huge relief effort came too late to prevent starvation and death. Farther east, meanwhile, towns and villages from Aberdeen to Wick and Thurso protested the cost of the oatmeal that replaced potatoes as the people’s basic foodstuff.<br/><br/> Oatmeal’s soaring price was blamed on the export of grain by farmers and landlords cashing in on even higher prices elsewhere. As a bitter winter gripped and families feared a repeat of the calamitous famine then ravaging Ireland, grain carts were seized, ships boarded, harbors blockaded, a jail forced open, and the military confronted. The army fired on one set of rioters. Savage sentences were imposed on others. But crowds of thousands also gained key concessions. Above all they won cheaper food.<br/><br/> Those dramatic events have long been ignored or forgotten. Now, in James Hunter, they have their historian. The story he tells is, by turns, moving, anger-making, and inspiring. In an era of food banks and growing poverty, it is also very timely.<br/><br/><b>Praise for <i>Insurrection</i></b><br/><br/><b>“Hunter never forgets that history is first of all narrative—and this book is rich in stories—or that is subject is the experience of individual men and women, creatures of flesh and blood, not abstractions. <i>Insurrection</i> is fascinating reading, both painful and uplifting.” —Allan Massie, <i>the Scotsman</i> (UK)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Hunter
      </h2>
      
      <p class="authorDescription body article">James Hunter is Emeritus Professor of History at the University of the Highlands and Islands and was its first Director of the Centre forHistory. He is the author of the award-winning Set Adrift Upon the World (Saltire Society History Book of the Year, 2016).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e58d9a1a